<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2024-01-31 09:38:44
 * @Description: 地下开挖
 * @LastEditors: Please set LastEditors
-->
<template>
  <div
    class="position-absolute left-container"
    :style="{ height: height, top: top, width: '388px!important', overflow: `visible !important` }"
  >
    <el-row
      type="flex"
      align="middle"
      class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
    >
      <el-col :span="18" class="fz-14 m-b-5px">地下开挖</el-col>
      <el-col :span="1" :offset="5">
        <span class="iconfont icon-line-close" @click="closeComponents"></span>
      </el-col>
    </el-row>

    <div class="h-[calc(100%-40px)] p-10px">
      <el-row :gutter="5" class=" mb-10px mt-10px ml-0 mr-0" align="middle">
        <el-col :span="4" :offset="0" class=" text-12px text-white h-32px leading-32px"
          >开挖对象</el-col
        >
        <el-col :span="15" :offset="0">
          <el-select
            v-model="codeList"
            placeholder="请选择开挖对象"
            size="small"
            class="text-12px w-full h-32px"
            popper-class="visualization-select-popper"
            multiple
            filterable
            remote
            data-cy="code"
            @remove-tag="removeTag"
          >
          </el-select>
        </el-col>
        <el-col :span="4" :offset="0" class="text-left">
          <el-button type="primary" class="text-12px" size="mini" @click="getSelectNode()"
            >获取</el-button
          >
        </el-col>
      </el-row>
      <el-row :gutter="5" class="mb-10px mt-10px ml-0 mr-0">
        <el-col :span="4" :offset="0" class="text-12px text-white h-32px leading-32px">
          开挖深度
        </el-col>
        <el-col :span="5" :offset="0">
          <el-input
            v-model="undergroundDeep"
            placeholder="开挖深度"
            size="small"
            clearable
            @change="setClipData()"
          ></el-input>
        </el-col>
        <el-col :span="1" :offset="0">
          <span class="text-white text-12px h-32px leading-32px">m</span>
        </el-col>
        <el-col :span="3" :offset="0" class="text-12px text-white h-32px leading-32px">
          坡度
        </el-col>
        <el-col :span="5" :offset="0">
          <el-input
            v-model="undergroundHeight"
            placeholder="高"
            size="small"
            clearable
            @change="setClipData()"
          ></el-input>
        </el-col>
        <el-col :span="1" :offset="0">
          <span class="text-white text-12px h-32px leading-32px">:</span>
        </el-col>
        <el-col :span="5" :offset="0">
          <el-input
            v-model="undergroundWidth"
            placeholder="宽"
            size="small"
            clearable
            @change="setClipData()"
          ></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="4" :offset="0" class="text-12px text-white h-32px leading-32px">
          偏移量
        </el-col>
        <el-col :span="5" :offset="0">
          <el-input
            v-model="offsetLocation[0]"
            placeholder="x"
            size="small"
            clearable
            @change="setClipData"
          ></el-input>
        </el-col>
        <el-col :span="5" :offset="0">
          <el-input
            v-model="offsetLocation[1]"
            placeholder="y"
            size="small"
            clearable
            @change="setClipData"
          ></el-input>
        </el-col>
        <el-col :span="5" :offset="0">
          <el-input
            v-model="offsetLocation[2]"
            placeholder="z"
            size="small"
            clearable
            @change="setClipData"
          ></el-input>
        </el-col>
      </el-row>

      <el-row type="flex" :gutter="5" align="middle" class="mb-10px" justify="space-between">
        <el-col :span="12">
          <div
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-checkbox-group v-model="clipList" class=" pl-10px text-12px" @change="onChange">
              <el-checkbox label="尺寸"></el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
        <el-col :span="12" :offset="0" class=" text-right pr-10px ">
          <el-button type="primary" size="mini" @click="resetDraw()">重新绘制</el-button>
        </el-col>
      </el-row>
      <div class="h-[calc(100%-235px)] mt-15px text-14px p-5px pt-10px">
        <el-row type="flex" align="middle" justify="space-between">
          <el-col :span="6" class="text-white"
            ><i class="el-icon-document mr-5p"></i>地下开挖</el-col
          >
          <el-col :span="8" class="text-right">
            <el-input
              @keyup.enter.native="getClipRecordList('referch')"
              size="small"
              clearable
              placeholder="请输入内容"
              v-model.trim="params.KeyWords"
            ></el-input
          ></el-col>
          <el-col :span="4">
            <el-tooltip content="搜索" placement="top" :open-delay="1000">
              <el-button
                type="primary"
                @click="getClipRecordList('referch')"
                size="mini"
                icon="el-icon-search"
                class="ml-5px"
              ></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" size="mini" @click="openClipDialog('')">保存</el-button>
          </el-col>
        </el-row>
        <el-row class="mt-5px h-[calc(100%-32px)] overflow-y-auto" v-loading="isloading">
          <div class="mb-10px" v-for="(item, index) in clipRecordList" :key="index">
            <img
              :src="item.imageContent"
              alt=""
              @click="viewItem(item)"
              class="tab-item-img align-top h-130px w-full rounded-5px"
            />
            <div
              class="flex tab-item-title text-white py-2px px-5px justify-between bg-[#46a6ff9c] h-25px"
            >
              <div>
                <span>{{ item.seqNo }}</span>
                <span class="pl-5px pr-5px text-12px">{{ item.fileName }}</span>
                <el-tooltip content="编辑" placement="top" :open-delay="1000">
                  <i class="el-icon-edit" @click="openClipDialog(item)"></i>
                </el-tooltip>
              </div>
              <div>
                <el-tooltip content="删除" placement="top" :open-delay="1000">
                  <i @click="deleteItem(item.id)" class="el-icon-delete"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <p class="text-center text-white mt-20px" v-if="!clipRecordList.length">暂无数据！</p>
        </el-row>
      </div>
      <div class="text-right mt-10px">
        <el-pagination
          background
          @size-change="getClipRecordList('referch')"
          @current-change="getClipRecordList"
          :current-page.sync="params.PageNo"
          :page-size.sync="params.PageSize"
          layout="total, prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
    <CockpitDialog
      class="fixed top-200px left-666px w-565px h-360px !bg-[#1b4555]"
      v-if="clipDialogShow"
      :title="isAdd ? '新增开挖数据' : '编辑开挖数据'"
      @close="close"
    >
      <div class="m-5px">
        <div class="w-500px mr-20px mt-30px">
          <el-form :model="clipForm" label-width="80px" :rules="clipRules" ref="addEditForm">
            <el-form-item label="序号" prop="seqNo">
              <el-input v-model.trim="clipForm.seqNo" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="文件名称" prop="fileName">
              <el-input v-model="clipForm.fileName" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="w-550px h-40px mt-90px ml-190px">
          <el-button @click="close" size="small">取 消</el-button>
          <el-button type="primary" @click="submitClip" size="small" :loading="submitLoading"
            >确 定</el-button
          >
        </div>
      </div>
    </CockpitDialog>
    <img :src="imgChangeUrl" alt="" class="mt-800px" id="rotateImg" />
  </div>
</template>

<script>
import html2canvas from 'html2canvas'

import { ThreeDimensionalSectioningApi, FileApi } from '@/services/cloud-render-management'
import cloudRender from '../js/model/index'
import CockpitDialog from './CockpitDialog'

export default {
  name: 'UnderClip',
  components: {
    CockpitDialog,
  },
  props: {
    currentFileId: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '50rem',
    },
    top: {
      type: String,
      default: '6.6rem',
    },
    currentComponent: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    const checkSeq = (rules, value, callback) => {
      if (!_.isSafeInteger(_.toNumber(value))) {
        callback(new Error('序号必须为整数类型'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      undergroundDeep: 1,
      undergroundHeight: 0,
      undergroundWidth: 0,
      codeList: [],
      clipList: ['尺寸'],
      clipRecordList: [],
      params: {
        PageSize: 5,
        PageNo: 1,
        KeyWords: '',
        SiteId: '',
        SectioningType: '',
        DocumentFileId: '',
      },
      pageTotal: 10,
      clipDialogShow: false, // 保存或者编辑剖切弹框显示与否
      isAdd: true, // 是否是新增操作
      isloading: false, // 是否正在加载中
      clipForm: {
        seqNo: '',
        fileName: '',
        sectioningType: 4,
        imgUrl: '',
        documentFileId: '',
        content: '',
        screenshotAttachmentId: '',
        siteId: '',
      },
      clipObjParams: {
        // 存在刨切的数据
        clipData: '',
        clipObjCodes: [],
      },
      imgChangeUrl: '', // 截图翻转之前的路径
      showTemporaryImg: false, // 临时展示的翻转后的模型截图
      clipRules: {
        seqNo: [
          { required: true, message: '请输入内容', trigger: 'change' },
          { required: true, validator: checkSeq, trigger: 'change' },
        ],
        fileName: [{ required: true, message: '请输入内容', trigger: 'change' }],
      },
      codeByItem: {},
      VerticesData: {},
      offsetLocation: [0, 0, 0.2],
      offsetLocationOld: [0, 0, 0.2],
      volumeId: '',
      heightId: '',
      SectioningType: 4, // 地下开挖
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  methods: {
    connectClipStatus({ detail }) {
      // 创建标签
      if (detail.status && detail.data) {
        this.VerticesData = detail.data.VerticesData
        this.setClipData()
        window.removeEventListener('Clip', this.connectClipStatus)
      }
    },
    /**
     * @description: 更新剖切数据
     * @return {*}
     */

    async setClipData() {
      const offset = []
      for (let i = 0; i < 3; i++) {
        offset[i] = (Number(this.offsetLocation[i]) || 0) - this.offsetLocationOld[i]
        this.offsetLocationOld[i] = offset[i] + this.offsetLocationOld[i]
      }
      const res = await cloudRender.Clip.setPloyonClipData(this.player, {
        height: this.undergroundDeep,
        ratio: this.undergroundHeight / this.undergroundWidth || 0,
        offset,
      })
      if (res && res.data) {
        this.VerticesData = res.data
      }
      await this.computedVolume()
    },
    /**
     * @description: 计算盒子的体积并绘制标签
     * @return {*}
     */

    async computedVolume() {
      // 求多边形面积
      const upArea = this.computedArea(this.VerticesData.upPanel)
      const downArea = this.computedArea(this.VerticesData.downPanel)
      // 求剖切盒子的体积
      const boxVolume = ((upArea + downArea) * Number(this.undergroundDeep)) / 2
      this.drawClipSizeMarker(
        this.VerticesData.upPanel,
        this.VerticesData.downPanel,
        boxVolume,
        Number(this.undergroundDeep)
      )
    },
    /**
     * @description: 根据点计算面积
     * @param {*} points
     * @return {*}
     */

    computedArea(points) {
      let area = 0
      points.forEach((element, index) => {
        if (index >= 2 && index < points.length - 1) {
          const w1 = Vec3.sub(points[index], points[0])
          const w2 = Vec3.sub(points[index - 1], points[0])
          const a = Vec3.length(Vec3.cross(w1, w2)) * 0.5
          area += a
        }
      })
      return area
    },
    /**
     * @description: 开挖对象列表change  - 点选
     * @return {*}
     */

    async getSelectNode() {
      const res = await cloudRender.Node.getSelectedItem(this.player)
      if (res && res.status) {
        const selectNode = res.data
        if (_.isEmpty(selectNode)) {
          this.$message({
            message: '请先选择模型',
            type: 'warning',
          })
          return
        }
        if (!selectNode.code) {
          this.$message({
            message: '请选择有位号的模型',
            type: 'warning',
          })
          return
        }
        this.codeList.push(selectNode.code)
        this.codeByItem[selectNode.code] = selectNode.item
        const items = []
        this.codeList.forEach((element) => {
          items.push(this.codeByItem[element])
        })
        cloudRender.Clip.setClipItem(this.player, items)
      }
    },
    removeTag(tag) {
      const items = []
      this.codeList.forEach((element) => {
        items.push(this.codeByItem[element])
      })
      cloudRender.Clip.setClipItem(this.player, items)
    },
    // 查看每一项的剖切状态
    async viewItem(item) {
      await this.cancelClip()
      // 移动相机
      // 移动相机
      const contentObj = JSON.parse(item.content)
      const cameraLocation = contentObj.cameraLocation
      cloudRender.Camera.moveCamera(this.player, 'CameraParam', JSON.stringify(cameraLocation), 2)
      this.offsetLocationOld = [0, 0, 0]
      this.offsetLocation = []
      this.undergroundDeep = contentObj.clipData.undergroundDeep
      const res = await cloudRender.Clip.setPloyonClipData(this.player, {
        VerticesData: contentObj.clipData.VerticesData.VerticesData,
        height: contentObj.clipData.undergroundDeep,
        ratio: this.undergroundHeight / this.undergroundWidth || 0,
      })
      if (res && res.data) {
        this.VerticesData = res.data
      }
      await this.computedVolume()
      const items = []
      this.codeList = contentObj.clipObjCodes
      if (contentObj.clipObjCodes.length) {
        for (let i = 0; i < contentObj.clipObjCodes.length; i++) {
          const element = contentObj.clipObjCodes[i]
          const resItemInfo = await cloudRender.Node.getInfo(this.player, 'Code', element)
          if (resItemInfo && resItemInfo.status) {
            items.push(resItemInfo.data.item)
          }
        }
      }
    },
    // 获取开挖数据列表
    async getClipRecordList(type) {
      this.isloading = true
      this.params.DocumentFileId = this.currentFileId
      this.params.SiteId = this.currentProject.id
      this.params.SectioningType = this.SectioningType
      if (type === 'referch') {
        this.params.PageNo = 1
      }
      const res = await ThreeDimensionalSectioningApi.queryList({
        documentFileId: this.params.DocumentFileId,
        sectioningType: this.params.SectioningType,
        sorting: 'seqNo',
        skipCount: (this.params.PageNo - 1) * this.params.PageSize, // Number |
        maxResultCount: this.params.PageSize, // Number |
      })
      console.log(res, '$$$$$$$$$$$$$$$$$$$$$$$')

      if (res) {
        this.clipRecordList = res.items
        _.forEach(this.clipRecordList, async (item) => {
          const imgRes = await this.getImageContent(item.screenshotAttachmentId)
          this.$set(item, 'imageContent', imgRes)
        })
        this.pageTotal = res.totalCount
      } else {
        this.pageTotal = 0
      }
      this.isloading = false
    },
    async getImageContent(id) {
      // 获取图片内容
      const result = await FileApi.getPublicImageBaseString(id)
      if (result) {
        return `data:image/png;base64,${result.base64}`
      }
      return ''
    },
    // 打开保存或编辑当前剖切记录弹框
    async openClipDialog(val) {
      this.clipDialogShow = true
      this.isAdd = !val
      this.clipForm = this.$options.data().clipForm
      if (val) {
        this.clipForm.fileName = val.fileName
        this.clipForm.seqNo = val.seqNo
        this.clipForm.id = val.id
        this.clipForm.content = val.content
        this.clipForm.screenshotAttachmentId = val.screenshotAttachmentId
        this.clipForm.documentFileId = val.documentFileId
      }
      // 新增操作时，截图操作
      const captureDom = document.querySelector('#engineId')
      this.showTemporaryImg = true
      this.imgChangeUrl = await this.getConvertToImage(captureDom)
      setTimeout(async () => {
        const captureDomAfter = document.querySelector('#rotateImg')
        this.clipForm.imgUrl = await this.getConvertToImage(captureDomAfter)
        this.showTemporaryImg = false
      }, 0)
      // 新增时获取刨切数据包
      this.clipObjParams = this.$options.data().clipObjParams
      this.clipObjParams.clipData = {
        VerticesData: this.VerticesData,
        undergroundDeep: Number(this.undergroundDeep),
        undergroundHeight: this.undergroundHeight,
        undergroundWidth: this.undergroundWidth,
      }
      const resItemInfo = await cloudRender.Clip.getClipObjects(this.player)
      if (resItemInfo && resItemInfo.status) {
        resItemInfo.data.forEach((itemInfo) => {
          if (_.trim(itemInfo.code)) {
            this.clipObjParams.clipObjCodes.push(itemInfo.code)
          }
        })
      }
    },
    // 获取截图后的快照
    getConvertToImage(container, options = {}) {
      // 获取指定的宽高
      const width = parseInt(window.getComputedStyle(container).width)
      const height = parseInt(window.getComputedStyle(container).height)
      // // html2canvas配置项
      const ops = {
        width,
        height,
        useCORS: true,
        allowTaint: true,
        ...options,
        dpi: 300,
      }
      return html2canvas(container, ops).then((canvas) => {
        return canvas.toDataURL('image/png')
      })
    },
    // 图片转文件
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    // 关闭弹框
    close() {
      this.clipDialogShow = false
      this.clipForm = this.$options.data().clipForm
      this.$refs.addEditForm.resetFields()
    },
    // 弹框确定操作
    submitClip() {
      this.$refs.addEditForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          // 摄像头位置
          this.clipObjParams.cameraLocation = await this.player.Native.CameraAnimation.cameraParam()
          this.clipForm.content = this.clipForm.content || JSON.stringify(this.clipObjParams)
          // 新增操作
          // 剖切截图上传
          const file = await this.dataURLtoFile(this.clipForm.imgUrl, `${this.generateUUID()}.png`)
          const formData = new FormData()
          formData.append('files', file)
          const res = await FileApi.upload_0({
            url: { authLevel: 2 },
            body: formData,
          })
          if (this.isAdd) {
            if (res && res.length) {
              const query = {
                content: this.clipForm.content,
                screenshotAttachmentId: res[0].id, // 截图文件id
                fileName: this.clipForm.fileName,
                documentFileId: this.currentFileId,
                sectioningType: this.SectioningType,
                seqNo: this.clipForm.seqNo,
              }
              const result = await ThreeDimensionalSectioningApi.create(query)
              if (result) {
                this.$message.success('新增成功！')
              }
            }
          } else {
            // 编辑操作
            const resultEdit = await ThreeDimensionalSectioningApi.update(this.clipForm.id, {
              content: this.clipForm.content,
              id: this.clipForm.id,
              screenshotAttachmentId: this.clipForm.screenshotAttachmentId || res[0].id, // 截图文件id
              fileName: this.clipForm.fileName,
              documentFileId: this.currentFileId,
              sectioningType: this.SectioningType,
              seqNo: this.clipForm.seqNo,
            })
            if (resultEdit) {
              this.$message.success('编辑成功！')
            }
          }
          this.getClipRecordList()
          this.submitLoading = false
          this.clipDialogShow = false
        }
      })
    },
    // 删除操作
    async deleteItem(val) {
      await ThreeDimensionalSectioningApi.callDelete_0(val)
      this.$message.success('删除成功！')
      this.getClipRecordList('referch')
    },
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    /**
     * @description: 标签的显示隐藏
     * @return {*}
     */

    async onChange() {
      const isShowMarker = this.clipList.includes('尺寸')
      const options = []
      if (this.volumeId) {
        options.push({
          id: this.volumeId,
          visible: isShowMarker,
        })
      }
      if (this.heightId) {
        options.push({
          id: this.heightId,
          visible: isShowMarker,
        })
      }
      cloudRender.Marker.updateBySingleLine(this.player, options)
    },
    async cancelClip() {
      await cloudRender.Clip.cancelPloygonClip(this.player)
      window.removeEventListener('Clip', this.connectClipStatus)
      await cloudRender.Marker.destroyMarker(this.player, [this.volumeId, this.heightId])
      this.undergroundDeep = 1
      this.undergroundHeight = 0
      this.undergroundWidth = 0
      this.offsetLocation = [0, 0, 0.2]
      this.volumeId = ''
      this.heightId = ''
      this.codeList = []
    },
    async drawClipSizeMarker(upPanel, downPanel, boxVolume, height) {
      const hPoint = [downPanel[0][0], downPanel[0][1], (downPanel[0][2] + upPanel[0][2]) / 2]
      if (this.volumeId && this.heightId) {
        await cloudRender.Marker.updateBySingleLine(this.player, [
          {
            id: this.volumeId,
            pos: upPanel[0],
            text: `体积:${boxVolume.toFixed(2)}m^3`,
          },
          {
            id: this.heightId,
            pos: hPoint,
            text: `高:${height}m`,
          },
        ])
        return
      }
      const res = await cloudRender.Marker.createBySingleLine(this.player, [
        {
          pos: upPanel[0],
          background: '#aea5e0',
          text: `体积:${boxVolume.toFixed(2)}m^3`,
          hasTriangle: false,
        },
        {
          pos: hPoint,
          background: '#aea5e0',
          text: `高:${height}m`,
          hasTriangle: false,
        },
      ])
      if (res && res.data) {
        ;[this.volumeId, this.heightId] = res.data
      }
    },
    // 重新绘制
    async resetDraw() {
      await this.cancelClip()
      window.addEventListener('Clip', this.connectClipStatus)
      await cloudRender.Clip.startDrawPloygonClip(this.player, {
        setIsInside: true,
        height: this.undergroundDeep,
        ratio: this.undergroundHeight / this.undergroundWidth || 0,
        offset: this.offsetLocation,
      })
    },
    closeComponents() {
      this.$emit('closeComponents', 'UndergroundClip')
    },
  },
  async beforeDestroy() {
    await this.cancelClip()
  },
  async created() {
    // 创建剖切
    await cloudRender.Clip.startDrawPloygonClip(this.player, {
      setIsInside: true,
      height: this.undergroundDeep,
      ratio: this.undergroundHeight / this.undergroundWidth || 0,
      offset: this.offsetLocation,
    })
    this.getClipRecordList('referch')
  },
  mounted() {
    window.addEventListener('Clip', this.connectClipStatus)
  },
}
</script>
<style lang="scss">

@import '../css/styles/select';

</style>
<style lang="scss" scoped>

@import '../css/component.scss';

#rotateImg {
  transform: rotateX(180deg);
}

:v-deep .el-checkbox__label {
  color: #fff !important;
}

.tab-item-title {
  border-radius: 0 0 5px 5px;
}

.tab-item-img {
  border-radius: 5px 5px 0 0;
}

</style>
